export const AUTO_REFRESH_TIMEOUT = 1 * 60 * 1000